/* @flow */

import * as React from 'react';

import {type ListOptionWithCount} from 'shells/select-option-components/option-with-count';
import {useGetSessionUser} from '../use-get-session-user';
import {useGetAudiences} from './hooks/use-get-audiences';

type Props = {|
    children: (ChildrenProps) => React.Node,
|};

type ChildrenProps = {
    options: ListOptionWithCount[],
    isLoading: boolean,
    refetch: () => Promise<*>,
};

export const GraphQLSelectAudiencesProvider = (props: Props) => {
    const {audiences, refetch, isLoading} = useGetAudiences();
    const {user} = useGetSessionUser();

    // map over the list to get the proper value/label options to pass
    // through to the select component below
    const audienceOptions: ListOptionWithCount[] = audiences.map((node) => ({
        value: node.id,
        label: node.name,
        count: node.membershipStats.totalCount,
        isFx: node.isWebFX,
        isSyncing: node.isSyncing,
    }));

    if (audienceOptions.length && user && user.permissions.canAccessMarketing) {
        audienceOptions.unshift({
            value: '__MANAGE__',
            label: '-- Manage audiences --',
            count: null,
        });
    }

    return props.children({
        options: audienceOptions,
        isLoading,
        refetch,
    });
};
